export default {
  getLoginErrors: (state) => state.auth.loginErrors,
  getResetPasswordErrors: (state) => state.auth.resetPasswordErrors,
  getCreatePasswordErrors: (state) => state.auth.newPasswordErrors,
  getAuthUri: (state) => state.auth.authorizationUri,

  selectTermsOfServiceModalVisible: (state) => state.auth.termsOfServiceModalVisible,
  selectLatestTermsOfService: (state) => state.auth.latestTermsOfService,
};
